import React from 'react';
import { Card, Placeholder } from 'react-bootstrap';

const EditJobSekeleton = () => {
	return (
		<Card style={{ width: '100%', maxWidth: '100%', height: '100%', marginLeft: '1rem' }}>
			<Card.Body>
				<Placeholder as={Card.Title} animation="glow">
					<Placeholder xs={6} />
				</Placeholder>
				<Placeholder as={Card.Text} animation="glow">
					<Placeholder xs={6} />
					<Placeholder xs={7} />
					<Placeholder xs={8} />
					<Placeholder xs={8} />
					<Placeholder xs={9} />
					<Placeholder xs={9} />
					<Placeholder xs={9} />
					<Placeholder xs={10} />
					<Placeholder xs={10} />
					<Placeholder xs={12} />
					<Placeholder xs={12} />
					<Placeholder xs={12} />
					<Placeholder xs={12} />
					<Placeholder xs={12} />
				</Placeholder>
				<Placeholder.Button style={{ minWidth: '30vw' }} variant="primary" xs={6} />
			</Card.Body>
		</Card>
	);
};

export default EditJobSekeleton;
